import { atom } from "recoil";
import { useDistanceOfPointsEsQuery } from "../../generated/graphql";

type DistanceOfPointsEsQueryStateType = Pick<ReturnType<typeof useDistanceOfPointsEsQuery>, 'data' | 'loading'>;
export const distanceOfPointsEsQueryState = atom<DistanceOfPointsEsQueryStateType>({
    key: "distanceOfPointsEsQueryState",
    default: { data: undefined, loading: true } as DistanceOfPointsEsQueryStateType,
});
